import { HTML_ENTITIES } from "~constants";

const HTML_TAGS_REGEX = /<\/?[^>]+>/gi;
const FIRST_CHAR_REGEX = /(?:^|\s)\S/g;
const NON_BREAKING_SPACE_REGEX = new RegExp(
    `${String.fromCharCode(160)}|&nbsp;`,
    "gi"
);
const HTML_ENTITIES_KEYS = Object.keys(HTML_ENTITIES).join("|");
const HTML_ENTITIES_REGEX = new RegExp(`&(${HTML_ENTITIES_KEYS});`, "g");
const NUMERIC_REFERENCE_REGEX = /&#(\d+);/gi;
const NON_CAPITAL_WORDS = new Set(["of"]);
const RX_WHITE_SPACES = /\s+/gm;

export function removeNBSP(text: string | null) {
    if (typeof text !== "string") {
        return text;
    }

    return text
        .replace(NON_BREAKING_SPACE_REGEX, " ")
        .replace(/\s+/g, " ")
        .trim();
}

export const removeHTML = (text: string | null) => {
    if (typeof text !== "string") {
        return text;
    }

    if (!text.match(HTML_TAGS_REGEX)) {
        return text;
    }

    return text.replace(HTML_TAGS_REGEX, " ").replace(/\s+/g, " ").trim();
};

function replaceHtmlEntity(_: string, entity: string) {
    return HTML_ENTITIES[entity];
}

function replaceNumericReference(_: string, numStr: string) {
    const num = parseInt(numStr, 10);
    return String.fromCharCode(num);
}

export const decodeHtmlEntities = (encodedString: string) =>
    encodedString
        .replace(HTML_ENTITIES_REGEX, replaceHtmlEntity)
        .replace(NUMERIC_REFERENCE_REGEX, replaceNumericReference);

export function capitalizeString(text: string) {
    return text
        .split(" ")
        .map((word) =>
            NON_CAPITAL_WORDS.has(word)
                ? word.toLowerCase()
                : word.charAt(0).toUpperCase() + word.substring(1)
        )
        .join(" ");
}

export function capitalizeDashedString(text?: string) {
    if (!text) {
        return null;
    }

    return text.split("-").map(capitalize).join(" ");
}

/**
 *
 * @param text string to uppercase
 * @param shouldLowercaseRestOfTheText  determines whether or not the rest of the string other than the first
 * letter should be lowercase
 * @returns {string}
 */
export function capitalize(text?: string, shouldLowercaseRestOfTheText?: any) {
    // allows for it to be used in `.map`
    if (typeof shouldLowercaseRestOfTheText !== "boolean") {
        shouldLowercaseRestOfTheText = true;
    }

    if (!text) {
        return "";
    }

    let newText = text;
    if (shouldLowercaseRestOfTheText) {
        newText = newText.toLowerCase();
    }

    return newText.replace(FIRST_CHAR_REGEX, (char) => char.toUpperCase());
}

export function removeDoubleSlashes(url: string) {
    if (!url) return "";
    return url.replace(/([^:]\/)\/+/g, "$1");
}

export function replaceSpacesWithUnderscores(str: string) {
    return str.replace(RX_WHITE_SPACES, "_");
}
